import { combineReducers } from 'redux'

import todos from './todos'
import listInfo from './listInfo'
import firestore from './firestore'

const rootReducer = combineReducers({
  todos,
  listInfo,
  firestore
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js